import React from "react";
// import HeaderButtons from "components/Button/HeaderButtons";

interface ViewReviewProps {
    // onClose: () => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
}

const ViewReview = ({  data }: ViewReviewProps) => {
    return (
        <div className="flex flex-col gap-6 pt-2 text-gray-800 dark:text-gray-200">

            <div className="flex flex-col gap-4">
                <div className="grid grid-cols-[140px_10px_1fr] items-center">
                    <span className="text-sm font-medium text-slate-700 dark:text-slate-300">Employee Name</span>
                    <span>:</span>
                    {/* Fallback to email if name is not available in the row data */}
                    <span className="text-sm">{data?.employeeName || data?.employeeEmail || "N/A"}</span>
                </div>

                <div className="grid grid-cols-[140px_10px_1fr] items-center">
                    <span className="text-sm font-medium text-slate-700 dark:text-slate-300">Reviewer</span>
                    <span>:</span>
                    <span className="text-sm">{data?.reviewer || "N/A"}</span>
                </div>

                <div className="grid grid-cols-[140px_10px_1fr] items-center">
                    <span className="text-sm font-medium text-slate-700 dark:text-slate-300">Review Date</span>
                    <span>:</span>
                    <span className="text-sm">{data?.reviewDate || "N/A"}</span>
                </div>

                <div className="grid grid-cols-[140px_10px_1fr] items-start">
                    <span className="text-sm font-medium text-slate-700 dark:text-slate-300">Review</span>
                    <span>:</span>
                    {/* Use the full review here, not the truncated one */}
                    <span className="text-sm whitespace-pre-wrap">{data?.review || "N/A"}</span>
                </div>
            </div>

            <hr className="border-gray-200 dark:border-gray-700" />

            {/* <div className="flex justify-end">
                <HeaderButtons
                    type="button"
                    variant="tertiary" // Or whatever variant produces the outlined blue button in your system
                    size="medium"
                    onClick={onClose}
                    className="px-6"
                >
                    Close
                </HeaderButtons>
            </div> */}
        </div>
    );
};

export default ViewReview;